import { render, staticRenderFns } from "./OptionArticleDialog.vue?vue&type=template&id=2432e440"
import script from "./OptionArticleDialog.vue?vue&type=script&lang=ts"
export * from "./OptionArticleDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports